import { ComparisonChartsPage, ComparisonChartsPageConfig } from '@app/components/page/ComparisonChartsPage'
import { BackofficeApiActions } from '@lib/Core/API/BackofficeApiActions'
import React from 'react'

const ComparisonChartsPageConfig: ComparisonChartsPageConfig = {
  tableName: 'profile_analysis',
  getFiltersActionName: BackofficeApiActions.GetUserInsightsFilters,
  getDataActionName: BackofficeApiActions.GetUserInsightsData,
  pageTitle: 'Compare users',
  pageDescription: 'Apply filters and explore results to discover new opportunities.',
}

const UserAnalysisComparison: React.FunctionComponent = () => {
  return <ComparisonChartsPage {...ComparisonChartsPageConfig}></ComparisonChartsPage>
}

export { UserAnalysisComparison }
